/**
 * @module app.devance.movements.parcMvtsCtrl
 */
define(['angular', 'moment'], function(angular, moment) {
    function ParcMvtsCtrl($scope, $window, $location, authService, mvtsService) {
        authService.updateLoginStatus(); // on verifie que le token est toujours là
         // $scope.selectActiveMenu(8);
        var vm = {};

        // Initialisation du paramétrage par défaut
        vm.mvts = [];
        vm.pageLimit = 500;
        vm.rowsCount = 0;
        vm.currentPage = 1;
        vm.pagesList = [1];
        vm.offset = (vm.currentPage - 1) * vm.pageLimit;
        
        vm.selectedMvtName = null;
        vm.mvtNameList = [{ id:'TOUS', label: 'TOUS'}];

        vm.selectedMvtStatus = null;
        vm.statusList = [{ id: 'TOUS', label: 'TOUS' }];
        vm.mvtStatusList = [];

        vm.diodList = null;

        vm.dateMin = new Date(moment().subtract(1, 'months').startOf('day').valueOf());

        vm.orderBy = {
            colName: null,
            sort: null
        };

        // Fonctions
        vm.orderByFunct = (colName) => {
            if(vm.orderBy.colName !== colName || (vm.orderBy.colName === colName && vm.orderBy.sort == null)) {
                vm.orderBy.colName = colName;
                vm.orderBy.sort = 'asc';
                vm.mvtsSearch();
                return;
            }
            if(vm.orderBy.sort === 'asc') {
                vm.orderBy.sort = 'desc';
            }
            else {
                vm.orderBy.sort = null;
            }
            vm.mvtsSearch();
        };

        vm.changePage = (pageVal) => {
            vm.currentPage = pageVal;
            vm.reinitTable();
            vm.loadTable();
        };

        vm.reinitTable = () => {
            vm.mvts = [];
            // vm.mvtNameList = ['TOUS'];
            // vm.statusList = [{ id: 'TOUS', label: 'TOUS' }];
        };

        vm.mvtsSearch = () => {
            // console.log('Paramètres de recherche', vm.getParams());
            vm.reinitTable();
            vm.loadTable();
        };

        vm.formatAddress = (coord) => {
            return coord ? coord.adresseA + (coord.adresseB ? ' ' + coord.adresseB + ' ' : '') : null;
        };

        vm.smartStatus = (status) => {
            return vm.status[status];
        };

        vm.getParams = () => {
            if(!vm.selectedMvtName) {
                vm.selectedMvtName = 'TOUS';
            }
            if(!vm.selectedMvtStatus) {
                vm.selectedMvtStatus = '0';
            }
            let typesParam = vm.selectedMvtName === 'TOUS' ?
                vm.mvtNameList.map(x => x.id).filter(x => x !== 'TOUS').join(',') : vm.selectedMvtName;
            let statutsParam = vm.selectedMvtStatus.toString()  === 'TOUS' ?
                vm.statusList.map(x => x.id).filter(x => x !== 'TOUS').join(',') : vm.selectedMvtStatus.toString();
            let dateMinParam = moment.unix(vm.dateMin.getTime() / 1000).toISOString(true);
            let diodListParam = vm.diodList || '';
            return [typesParam, statutsParam, diodListParam, dateMinParam, vm.orderBy.colName, vm.orderBy.sort];
        };

        vm.loadTable = () => {
            return mvtsService.listParcMvtsTypes()
                .then((types) => {
                    if(!vm.selectedMvtName) {
                        vm.mvtNameList = vm.mvtNameList.concat(types);
                    }
                    return mvtsService.listParcStatus();
                })
                .then((status) => {
                    if(!vm.selectedMvtStatus) {
                        vm.statusList = vm.statusList.concat(status);
                        vm.mvtStatusList = vm.mvtStatusList.concat(status);
                    }
                    return mvtsService.countMvts(vm.getParams());
                })
                .then((count) => {
                    vm.rowsCount = count.count;
                    vm.offset = (vm.currentPage - 1) * vm.pageLimit;
                    vm.nbPage = Math.ceil(vm.rowsCount / vm.pageLimit);
                    vm.pagesList = [];
                    for(let index = 1; index <= vm.nbPage; index++) {
                        vm.pagesList.push(index);
                    }

                    let params = vm.getParams();
                    params.push(vm.offset);
                    return mvtsService.listMvts(params);
                })
                .then((rows) => {
                    vm.mvts = rows;
                })
                .catch((err) => {
                    console.error(err);
                    vm.displayError(err);
                });
        };

        // Modal comparator
        vm.comparator = (diod, mvt) => {
            vm.comparatorModal = {
                devancePosInfos: {},
                posX3List: [],
                isSearch: false
            };
            vm.comparatorModal.diod = diod;
            vm.comparatorModal.mvt = mvt;
            return mvtsService.getDevancePosInfos(diod)
                .then((posInfos) => {
                    console.log('posInfos', posInfos);
                    vm.comparatorModal.devancePosInfos = posInfos;
                    $('#comparatorModal').modal('show');
                })
                .catch((err) => {
                    console.error(err);
                    vm.displayError(err);
                });
        };

        // Modal error
        vm.errorModal = {
            error: null
        };

        vm.displayError = (err) => {
            vm.errorModal.error = err;
            $('#errorModal').modal('show');
        };

        vm.x3PosSearch = () => {
            let search = {
                diod: vm.comparatorModal.devancePosInfos.diod,
                siret: vm.comparatorModal.devancePosInfos.siret || 'null',
                tvaIntra: vm.comparatorModal.devancePosInfos.tvaIntraCommunautaire || 'null',
                raisonSociale: vm.comparatorModal.devancePosInfos.raisonSociale,
                coordonnees: vm.comparatorModal.devancePosInfos.coordonnees,
                telephone: vm.comparatorModal.devancePosInfos.telephone.replaceAll(' ', '').replace('+33', '0'),
                mail: vm.comparatorModal.devancePosInfos.mail
            };
            return mvtsService.getX3PosSearch(search)
                .then((posX3List) => {
                    // console.log('posX3List', posX3List);
                    vm.comparatorModal.posX3List = posX3List;
                    vm.comparatorModal.isSearch = true;
                })
                .catch((err) => {
                    console.error(err);
                    vm.displayError(err);
                });
        };

        vm.updateStatus = (diod, type, date_demande, newStatus, reThrow) => {
            return mvtsService.updateMvtStatus(diod, type, date_demande, newStatus)
                .then((res) => {
                    console.log('updateStatus', diod, type, date_demande, res);
                    vm.showToast();
                })
                .catch((err) => {
                    if(reThrow)
                        throw err;
                    console.error(err);
                    vm.displayError(err);
                });
        };

        vm.treatMvt = (mvt, status) => {
            console.log('traiter : ' + mvt.diod + ' ' + mvt.type + ' ' + mvt.date_demande);
            for(let i = 0; i < vm.mvts.length; i++) {
                if(vm.mvts[i] && (vm.mvts[i].diod+vm.mvts[i].type+vm.mvts[i].date_demande === mvt.diod+mvt.type+mvt.date_demande)) {
                    vm.updateStatus(vm.mvts[i].diod, vm.mvts[i].type, vm.mvts[i].date_demande, status, true)
                        .then(() => {
                            vm.mvts[i].statut = status.toString();
                        })
                        .catch((err) => {
                            console.error(err);
                            vm.displayError(err);
                        });
                }
            }
        };

        vm.showToast = () => {
            $('#liveToast').toast('show');
        };

        vm.goTo = (path) => {
            $location.path(path);
        };

        vm.getEnterKey = (event) => {
            if(event && event.keyCode === 13) {
                vm.mvtsSearch();
            }
        };

        vm.copyClipboard = (str) => {
            navigator.clipboard.writeText(str);
        };

        // Chargement des données
        vm.loadTable();

        return vm;
    }

    ParcMvtsCtrl.$inject = [
        '$scope', '$window', '$location', 'authService', 'mvtsService'
    ];

    angular
        .module('app.devance.movements.parcMvtsCtrl', ['ui.bootstrap', 'ui-notification'])
        .controller('ParcMvtsCtrl', ParcMvtsCtrl);
});
